'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _helpers = require('../../../../helpers/');

require('./ValidationInputs.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _antd.Form.Item;
var InputGroup = _antd.Input.Group;
var debounce = require('lodash/function/debounce');
var delay = require('lodash/function/delay');

var nothingFoundLabel = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'validationInputs.location.lookup.no.results.label',
  defaultMessage: 'Nothing found...'
});

var ValidationInputs = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ValidationInputs, _Component);

  function ValidationInputs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ValidationInputs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ValidationInputs.__proto__ || (0, _getPrototypeOf2.default)(ValidationInputs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      locations: {
        data: [],
        loading: false,
        error: null,
        query: null
      },
      isValid: null
    }, _this.getValueField = function (format) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var name = arguments[4];

      var fieldMarkup = void 0;
      var formItemProps = void 0;
      switch (format) {
        case 'checkbox':
          {
            fieldMarkup = (0, _helpers.getFieldByType)('checkbox', (0, _extends3.default)({}, props, {
              onChange: function onChange() {
                _this.checkValidation([name]);
              }
            }), children);
            break;
          }
        case 'percent':
          {
            fieldMarkup = (0, _helpers.getFieldByType)('input-number', (0, _extends3.default)({}, props, {
              formatter: function formatter(value) {
                return '% ' + (0, _helpers.numberMask)(value);
              },
              parser: function parser(value) {
                return value.replace(/%\s?|(,*)/g, '');
              },
              onKeyUp: function onKeyUp() {
                _this.checkValidation([name]);
              },
              onChange: function onChange() {
                delay(_this.checkValidation, 50, [name]);
              },
              style: {
                width: 80
              }
            }));
            break;
          }
        case 'currency':
          {
            fieldMarkup = (0, _helpers.getFieldByType)('input-number', (0, _extends3.default)({}, props, {
              formatter: function formatter(value) {
                return '$ ' + (0, _helpers.numberMask)(value);
              },
              parser: function parser(value) {
                return value.replace(/\$\s?|(,*)/g, '');
              },
              onKeyUp: function onKeyUp() {
                _this.checkValidation([name]);
              },
              onChange: function onChange() {
                delay(_this.checkValidation, 50, [name]);
              },
              style: {
                width: 100
              }
            }));
            break;
          }
        case 'decimal':
        case 'numeric':
        case 'integer':
          {
            fieldMarkup = (0, _helpers.getFieldByType)('input-number', (0, _extends3.default)({}, props, {
              onKeyUp: function onKeyUp() {
                _this.checkValidation([name]);
              },
              onChange: function onChange() {
                delay(_this.checkValidation, 50, [name]);
              },
              style: {
                width: 80
              }
            }));
            break;
          }
        case 'multiselect':
          {
            fieldMarkup = (0, _helpers.getFieldByType)('select', (0, _extends3.default)({}, props, {
              mode: 'multiple',
              filterOption: function filterOption(input, option) {
                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              },
              onSelect: function onSelect() {
                delay(_this.checkValidation, 50, [name]);
              },
              onChange: function onChange() {
                delay(_this.checkValidation, 50, [name]);
              },
              dropdownMatchSelectWidth: false
            }), children);
            break;
          }
        case 'select':
          {
            fieldMarkup = (0, _helpers.getFieldByType)('select', (0, _extends3.default)({}, props, {
              filterOption: function filterOption(input, option) {
                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              },
              onSelect: function onSelect() {
                delay(_this.checkValidation, 50, [name]);
              },
              onChange: function onChange() {
                delay(_this.checkValidation, 50, [name]);
              },
              dropdownMatchSelectWidth: false
            }), children);
            break;
          }
        case 'location-lookup':
          {
            formItemProps = {
              hasFeedback: _this.state.locations.loading === true,
              validateStatus: _this.state.locations.loading === true ? "validating" : null
            };

            var _children = _this.state.locations.data.map(function (location) {
              return {
                label: location.city_name + ', ' + location.state_abbr + ', ' + location.country_abbr,
                value: '' + location.id
              };
            });

            var debouncedFetchLocations = debounce(function (value) {
              options.fetchLocationsAction(value, function (data) {
                _this.setState({
                  locations: (0, _assign2.default)({}, _this.state.locations, {
                    data: data,
                    error: null,
                    loading: false
                  })
                });
              }, function (err) {
                _this.setState({
                  locations: (0, _assign2.default)({}, _this.state.locations, {
                    data: [],
                    error: err,
                    loading: false
                  })
                });
              });
            }, 250, {
              leading: false,
              trailing: true
            });

            fieldMarkup = (0, _helpers.getFieldByType)('select', (0, _extends3.default)({}, props, {
              notFoundContent: _this.state.locations.data.length === 0 && _this.state.locations.query ? nothingFoundLabel : false,
              onSearch: function onSearch(value) {
                if (value) {
                  _this.setState({
                    locations: (0, _assign2.default)({}, _this.state.locations, {
                      error: null,
                      loading: true,
                      query: value
                    })
                  });
                  debouncedFetchLocations(value);
                }
              },
              filterOption: false,
              allowClear: false,
              optionFilterProp: 'value',
              optionLabelProp: 'label',
              showSearch: true,
              labelInValue: true,
              onSelect: function onSelect() {
                delay(_this.checkValidation, 50, [name]);
              },
              onChange: function onChange() {
                delay(_this.checkValidation, 50, [name]);
              },
              dropdownMatchSelectWidth: false
            }), _children);
            break;
          }
        case 'string':
          {
            fieldMarkup = (0, _helpers.getFieldByType)('input', (0, _extends3.default)({}, props, {
              onKeyUp: function onKeyUp() {
                _this.checkValidation([name]);
              }
            }));
            break;
          }
        default:
          break;
      }
      return {
        formItemProps: formItemProps,
        element: fieldMarkup
      };
    }, _this.getRequiredFields = function (fields) {
      var requiredFields = [];
      fields.forEach(function (field) {
        if (field.decorator && field.decorator.rules && field.decorator.rules.length && field.decorator.rules[0].required) {
          requiredFields.push(field.name);
        }
        if (field.buddy && field.buddy.decorator && field.buddy.decorator.rules && field.buddy.decorator.rules.length && field.buddy.decorator.rules[0].required) {
          requiredFields.push(field.buddy.name);
        }
      });
      return requiredFields;
    }, _this.checkRequiredFieldsValue = function () {
      var _this$props = _this.props,
          form = _this$props.form,
          fields = _this$props.fields;

      var requiredFields = _this.getRequiredFields(fields);
      var isValid = true;
      requiredFields.forEach(function (requiredFieldName) {
        var fieldTrueValue = form.getFieldValue(requiredFieldName);
        var parsedValue = void 0;
        if (requiredFieldName === 'location') {
          parsedValue = fieldTrueValue.key !== '' ? fieldTrueValue : null;
        } else {
          parsedValue = fieldTrueValue;
        }
        if (typeof parsedValue === 'undefined' || parsedValue === null) {
          isValid = false;
        }
      });

      if (isValid) {
        _this.props.isValid(true, true);
      } else {
        _this.props.isValid(false, false);
      }
    }, _this.checkValidation = function (fields) {
      var isValid = true;
      _this.props.form.validateFields(fields, function (error, value) {
        if (error) {
          isValid = false;
        }
      });

      if (isValid) {
        _this.checkRequiredFieldsValue();
      } else {
        _this.props.isValid(false, true);
      }
    }, _this.renderFields = function (fields) {
      if (fields && fields.length) {
        var getFieldDecorator = _this.props.form.getFieldDecorator;

        return fields.map(function (fieldObject) {
          var mainField = _this.getValueField(fieldObject.format, (0, _extends3.default)({}, fieldObject.props), fieldObject.children, fieldObject.options, fieldObject.name);
          var fieldRender = void 0;
          if (fieldObject.buddy) {
            var buddyField = _this.getValueField(fieldObject.buddy.format, (0, _extends3.default)({}, fieldObject.buddy.props, {
              style: {
                width: 80
              }
            }), fieldObject.buddy.children, fieldObject.buddy.options, fieldObject.buddy.name);
            fieldRender = _react2.default.createElement(
              InputGroup,
              { compact: true, className: 'input-with-buddy suffixed', key: 'buddy-field' },
              getFieldDecorator(fieldObject.name, (0, _extends3.default)({}, fieldObject.decorator, { validateTrigger: false }))(mainField.element),
              getFieldDecorator(fieldObject.buddy.name, (0, _extends3.default)({}, fieldObject.buddy.decorator, { validateTrigger: false }))(buddyField.element)
            );
          } else {
            fieldRender = getFieldDecorator(fieldObject.name, (0, _extends3.default)({}, fieldObject.decorator, { validateTrigger: false }))(mainField.element);
          }

          return _react2.default.createElement(
            FormItem,
            (0, _extends3.default)({}, fieldObject.formItem, {
              colon: false,
              className: 'warning-field'
            }, mainField.formItemProps, {
              key: fieldObject.id ? fieldObject.id : fieldObject.name
            }),
            fieldRender
          );
        });
      }
      return null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ValidationInputs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.for !== nextProps.for) {
        this.props.form.resetFields();
        this.props.isValid(false, false);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.for !== nextProps.for || this.props.form !== nextProps.form || this.props.fields !== nextProps.fields || this.state !== nextState;
    }

    /**
     * This method is responsible for maintaining a collection
     * different types of fields required by FE to i/o the data
     * required by BE dynamically, essentially based on the
     * 'format' field of a trigger. We pass in the field's
     * parentValueEntity and valueEntity props in order to
     * map the corresponding fields in our local form state,
     * along with the defaultValue and any suggestedOptions
     * (for Select elements).
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'validationInputs__component' },
        _react2.default.createElement(
          _antd.Form,
          { layout: 'inline', hideRequiredMark: true },
          _react2.default.createElement(
            _antd.Row,
            null,
            this.renderFields(this.props.fields)
          )
        )
      );
    }
  }]);
  return ValidationInputs;
}(_react.Component), _class.propTypes = {
  form: _propTypes2.default.shape({
    getFieldDecorator: _propTypes2.default.func.isRequired,
    getFieldsError: _propTypes2.default.func.isRequired,
    validateFields: _propTypes2.default.func.isRequired,
    resetFields: _propTypes2.default.func.isRequired,
    setFields: _propTypes2.default.func.isRequired
  }).isRequired,
  for: _propTypes2.default.string,
  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    format: _propTypes2.default.oneOf(['percent', 'checkbox', 'currency', 'decimal', 'tags', 'numeric', 'integer', 'multiselect', 'select', 'location-lookup', 'string']).isRequired,
    children: _propTypes2.default.arrayOf(_propTypes2.default.any),
    options: _propTypes2.default.object,
    formItem: _propTypes2.default.shape({
      label: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    }),
    decorator: _propTypes2.default.shape({
      rules: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        required: _propTypes2.default.bool,
        message: _propTypes2.default.string
      })),
      initialValue: _propTypes2.default.any
    })
  })),
  isValid: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  fields: [],
  for: 'validation-inputs-form'
}, _temp2);
exports.default = _antd.Form.create({
  onFieldsChange: function onFieldsChange(props, fields) {
    var updates = {};
    (0, _keys2.default)(fields).forEach(function (fieldName) {
      updates[fieldName] = fields[fieldName].value;
    });
    props.onChange(updates);
  }
})(ValidationInputs);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/ValidationInputs.js
// module id = 3785
// module chunks = 4